import type { RevenuePage } from '@servwell/shared';
import { Button } from '../../ui/Button';
import { downloadReportCsv } from '../ReportView';
import { revenueCsv, revenueCsvTitle } from './revenueCsv';

/**
 * The Revenue page's Download CSV (ticket 08), over the answer the page draws. With no answer
 * on screen there is nothing to save, so no button. Hook-free, so a test can press it.
 */
export function DownloadCsv({ data }: { data: RevenuePage | undefined }) {
  if (!data) return null;
  return (
    <Button
      variant="ghost"
      className="ml-auto"
      onClick={() => downloadReportCsv(revenueCsv(data), revenueCsvTitle(data))}
    >
      Download CSV
    </Button>
  );
}
